import { Button, Form, Modal } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../../redux/useAppDispatch";
import { RootState } from "../../../../../redux/store";
import "./AssignUserModal.css";

import Search from "antd/es/input/Search";
import { assignUsers, getUnassignedUsers } from "../../../../../redux/SettingModule/OrganizationDetailPage/OrganizationDetailAction";
import DebounceSelect from "./DebounceSelect";
import { set } from "lodash";

type AssignUserModalProps = {
  close: () => void;
  openState: boolean;
  open: () => void;
  tenantId: number | undefined;
};

function AssignUserModal(props: AssignUserModalProps) {
  const unassignedUsers = useSelector((state: RootState) => state.OrganizationDetailPageState.unassignedUser);
  const loading = useSelector((state: RootState) => state.OrganizationDetailPageState.assignUsersLoading);
  const [error, setError] = useState<string>("");

  const [value, setValue] = useState<any[]>([]);

  // const [templateType, setTemplateType] = useState(""); // = useState

  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  // useEffect(() => {
  //   // dispatch(
  //   //   getTemplateOptions({
  //   //     id: props.packDetail.idTenant,
  //   //     type: props.packDetail.transcriptions[0].transcriptionType,
  //   //   })
  //   // );
  //   dispatch(getUnassignedUsers(props.tenantId));
  // }, [props.openState]);

  const resetForm = () => {
    form.resetFields();
  };
  useEffect(() => {
    return () => {
      setValue([]);
      resetForm();
    };
  }, [props.openState]);
  const AssignUserModalContent = useMemo(() => {
    const onFinish = async (value: any) => {
      const payload = {
        IdTenant: props.tenantId,
        UserIds: value.Template.map((user: any) => user.value),
      };

      try {
        await dispatch(assignUsers(payload)).unwrap();
        props.close();
        form.resetFields();
      } catch (error) {
        setError("Error assigning users, please try again.");
        console.error("Error assigning users:", error);
      }
    };

    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4>Search Users</h4>

        <Form
          form={form}
          name="exportOptions"
          onFinish={onFinish}
          initialValues={{ isDummyDomain: false }}
          colon={false}>
          <Form.Item
            className=""
            // label="Assign User"
            name="Template"
            labelAlign="left"
            required={true}
            // rules={[
            //   {
            //     required: true,
            //     pattern: /^[0-9]*$/,
            //     message: "Please provide a valid Template.",
            //   },
            // ]}
            validateTrigger="onBlur">
            <DebounceSelect
              mode="multiple"
              value={value}
              placeholder="Search Users"
              fetchOptions={async (search: string) => {
                const response = await dispatch(getUnassignedUsers(props.tenantId));
                return response.payload;
              }}
              onChange={(newValue) => {
                if (Array.isArray(newValue)) {
                  setValue(newValue);
                }
              }}
              style={{ width: "100%" }}
            />
          </Form.Item>
          {error && <div className="error justify-content-end align-self-end mb-2">{error}</div>}
          <div className="d-flex gap-3 justify-content-end">
            <Button
              htmlType="reset"
              loading={loading}
              onClick={() => {
                props.close();
              }}>
              Cancel
            </Button>

            <Button
              className="saveButton"
              type="primary"
              loading={loading}
              // loading={uploadLoading}
              htmlType="submit">
              Add
            </Button>
          </div>
        </Form>
      </div>
    );
  }, [form, props, loading, error]);

  useEffect(() => {
    return () => {
      setValue([]);
      setError("");
    };
  }, [props.openState]);
  return (
    <Modal
      width={376}
      // className="modal-container"
      centered
      zIndex={1500}
      footer={[]}
      onCancel={() => props.close()}
      open={props.openState}>
      {AssignUserModalContent}
    </Modal>
  );
}

export default AssignUserModal;
